import { MDBDatatable, MDBIcon, MDBInput, MDBTextArea } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import ToggleEditWarning from "../hunt/ToggleEditWarning";
import PopupLoader from "../../../views/popups/PopupLoader";
import TextareaAutosize from 'react-textarea-autosize'
import { Tooltip } from "react-tooltip";
import { customSearch } from "../../CustomSearchUtil/CustomSearch";

function LunaHuntGroup({ huntGroups, hgTextValue, hgError, sethgError, onResetDone }) {
  const [selectAllRadio, setselectAllRadio] = useState("-1");
  const [updateFieldName, setupdateFieldName] = useState("");
  const [updateFieldValue, setupdateFieldValue] = useState("");
  const [toggleValue, settoggleValue] = useState(-1);
  const [columnName, setcolumnName] = useState("");
  const [editWarning, seteditWarning] = useState(false);
  const warningToggle = () => seteditWarning(!editWarning);
  const [focusedIndex, setFocusedIndex] = React.useState(null);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [filteredIndices, setFilteredIndices] = useState([]);
  const [hgText, sethgText] = useState({});
  const {
    setValue,
    watch,
    control,
    reset,
    clearErrors,
    register,
    formState: { errors },
  } = useFormContext();
  const { fields } = useFieldArray({
    name: "hg.edit_perm",
    control,
  });

  useEffect(() => {
    if (huntGroups && huntGroups.length > 0) {
      reset((prev) => ({ ...prev, hg: { ...prev.hg, edit_perm: huntGroups } }));
      onResetDone?.();
    }
  }, [huntGroups]);

  function handleAllChange(feildName, columnName, value) {
    sethgError("");
    clearErrors(`hg.is_perm_enabled`);
    if (value !== "-1") {
      setupdateFieldName(feildName);
      setupdateFieldValue(value);
      seteditWarning(true);
      // setuniqueKeyValue(resetFieldid);
      settoggleValue(value);
      setcolumnName(columnName);
    }
  }

  function handleCloseWarning() {
    setselectAllRadio("-1");
    warningToggle();
  }

  function handleUpdateToggle() {
    fields.forEach((field, index) => {
      setValue(
        `hg.edit_perm.${index}.${updateFieldName}`,
        updateFieldValue ? 1 : 0,
        {
          shouldDirty: true,
        }
      );
    });

    setselectAllRadio("-1");
    warningToggle();
  }

  useEffect(() => {
    setSearchValue("")
    if (fields && Array.isArray(fields) && fields.length > 0) {
      setFilteredIndices(fields.map((_, index) => index));
    } else {
      setFilteredIndices([]);
    }
  }, [fields.length]);
  useEffect(() => {
    if (hgTextValue && Object.entries(hgTextValue).length > 0) {
      sethgText(hgTextValue);
    }
  }, [hgTextValue]);

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleInfoChange(index, code, value) {
    sethgText((prev) => ({ ...prev, [code]: value }));
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      setValue(`hg.edit_perm.${index}.info`, value, {
        shouldDirty: true,
      });
      clearErrors(`hg.is_perm_enabled`);
    }, 100);
    setTypingTimeout(newTimeout);
  }

  const handleSearch = (value) => {
    setSearchValue(value);

    if (!fields || fields.length === 0) {
      setFilteredIndices([]);
      return;
    }

    if (!value.trim()) {
      setFilteredIndices(fields.map((_, index) => index));
      return;
    }

    const filterResult = customSearch(fields, value, ["title", "extensions"]);

    const matchingIndices = filterResult
      .map((filteredItem) =>
        fields.findIndex(
          (field) =>
            field &&
            (field.id === filteredItem.id ||
              (field.title === filteredItem.title &&
                field.extensions === filteredItem.extensions))
        )
      )
      .filter((index) => index !== -1);

    setFilteredIndices(matchingIndices);
  };


  let processdrows = [];
 // Add safety check for fields and filteredIndices
  if (fields && fields.length > 0 && filteredIndices.length > 0) {
    filteredIndices.forEach((originalIndex) => {
      const hg = fields[originalIndex];
      
      // Additional safety check for the individual field object
      if (!hg || typeof hg !== 'object') return;
      
    const isFocused = focusedIndex === originalIndex;
    processdrows.push({
      hgInfo: hg,
      name: hg.title || '',
      extension: hg.extensions || '',
      information: (
        <>
          {watch(`hg.edit_perm.${originalIndex}.flag`) === 1 ? (
            <div className={`position-relative ${isFocused ? "" : "no-scrollbar-textarea"}`}>
              <TextareaAutosize
                minRows={isFocused ? 8 : 3}
                maxRows={isFocused ? 8 : 3}
                className="w-100"
                type="text"
                maxLength={500}
                {...register(`hg.edit_perm.${originalIndex}.info`)}
                onFocus={() => setFocusedIndex(originalIndex)}
                onBlur={() => setFocusedIndex(null)}
                onChange={(e) => {
                  sethgError("");
                  setValue(`hg.edit_perm.${originalIndex}.info`, e.target.value, {
                    shouldDirty: true,
                  });
                  clearErrors(`hg.is_perm_enabled`);
                }}
              />
              <div
                className="text-muted text-end lh-normal pe-1 pb-1 "
                style={{
                  fontSize: "10.5px",
                  pointerEvents: "none"
                }}
              >
                {watch(`hg.edit_perm.${originalIndex}.info`)?.length || 0}/500
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      ),
      active: (
        <>
          <div className="d-flex align-items-center flex-column justify-content-center">

            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  checked={watch(`hg.edit_perm.${originalIndex}.flag`) === 1}
                  onChange={(e) => {
                    sethgError("");
                    clearErrors(`hg.is_perm_enabled`);
                    setValue(
                      `hg.edit_perm.${originalIndex}.flag`,
                      e.target.checked ? 1 : 0,
                      { shouldDirty: true }
                    );
                  }}
                  name="DefualtLocation"
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </>
     ),
      });
    });
  }


  const HuntGroups = {
    columns: [
      {
        label: (
          <>
            Name
          </>
        ),
        field: "name",
      },
      {
        label: (
          <>
            Extension
          </>
        ),
        field: "extension",
      },
      ,
      {
        label: (
          <>
            <div className="fw-bold">Information <MDBIcon icon="info-circle" className="ms-3 hunt_info" /></div>
          </>
        ),
        field: "information",
        sort: false,
      },
      {
        label: (
          <>
            <div className="d-flex align-items-center flex-column justify-content-center">
              <p className="fw-bold">Active</p>

              {/* <div className="three-checkbox round2 mx-0">
                <input
                  type="radio"
                  name="ActiveValue02"
                  checked={selectAllRadio === false}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio(false);
                      handleAllChange("flag", "Active", false);
                    }
                  }}
                />
                <input
                  type="radio"
                  name="ActiveValue02"
                  checked={selectAllRadio === "-1"}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio("-1");
                      handleAllChange("flag", "Active", "-1");
                    }
                  }}
                />
                <input
                  type="radio"
                  name="ActiveValue02"
                  checked={selectAllRadio === true}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio(true);
                      handleAllChange("flag", "Active", true);
                    }
                  }}
                />
                <span className="slider"></span>
              </div>  */}
            </div>
          </>
        ),
        field: "active",
        sort: false,
      },
    ],
    rows: processdrows,
  };

  return (
    <>
      <div className="section-content">
        <div className="d-flex align-items-center justify-content-between mb-3 pe-4">
          <div className="general-settings m-0">Hunt Groups</div>
          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                name="DefualtLocation"
                // value={watch(`hg.is_perm_enabled`)}
                checked={watch(`hg.is_perm_enabled`)}
                onChange={(e) => {
                  sethgError("");
                  clearErrors(`hg.is_perm_enabled`);
                  setValue(`hg.is_perm_enabled`, e.target.checked, {
                    shouldDirty: true,
                  });
                }}
              />
              <span className="slider round"></span>
            </label>
            {errors?.hg?.is_perm_enabled && (
              <p className="text-danger">
                {errors?.hg?.is_perm_enabled?.message}
              </p>
            )}
          </div>
        </div>
        {hgError && <p className="text-danger">{hgError}</p>}
        {watch("hg.is_perm_enabled") && (
          <>
            <div className="actionbar"></div>
             <div className='mb-2 mt-0 position-relative w-auto'>
              <MDBInput
                label="Search"
                value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <MDBDatatable
              className="actioncolumn LunaUsersDataTable"
              key={searchValue}
              // pagination={false}
              // search
              hover
              fixedHeader
              data={HuntGroups}
            />
          </>
        )}
      </div>
      {editWarning && (
        <PopupLoader
          size="md"
          title="Warning"
          content={
            <ToggleEditWarning
              handleUpdateToggle={handleUpdateToggle}
              handleCloseWarning={handleCloseWarning}
              toggleValue={null}
              columnName={columnName}
              isLuna={true}
            />
          }
          onShow={seteditWarning}
          onClose={handleCloseWarning}
        />
      )}


      <Tooltip anchorSelect=".hunt_info" place="top" className="exampleTooltipLight">
        Tells Luna what each active Hunt Group is Used for.
      </Tooltip>
    </>
  );
}

export default React.memo(LunaHuntGroup);
